import { Routes } from '@angular/router';
import { MainLayoutComponent } from './components/layout/main-layout/main-layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TenantDashboardComponent } from './components/tenant-dashboard/tenant-dashboard.component';
import { TenantBaseComponent } from './components/tenant-base/tenant-base.component';
import { TenantServicesComponent } from './components/tenant-services/tenant-services.component';
import { TenantSsoComponent } from './components/tenant-sso/tenant-sso.component';
import { TenantUsersComponent } from './components/tenant-users/tenant-users.component';
import { TenantRoleComponent } from './components/tenant-role/tenant-role.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'users', component: TenantUsersComponent },
      { path: 'tenants', component: TenantDashboardComponent },
      { path: 'tenants/:slug', component: TenantBaseComponent },
      { path: 'tenants/:slug/services', component: TenantServicesComponent },
      { path: 'tenants/:slug/sso', component: TenantSsoComponent },
      { path: 'tenants/:slug/users', component: TenantUsersComponent },
      { path: 'tenants/:slug/roles', component: TenantRoleComponent }
    ]
  }
];
